import { Button, Flex, Form, Modal, Typography, Input } from 'antd';
import { useContext, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { showNotification } from 'src/utils/notification';
import { getPayslip } from 'src/apis/hr_ticket/salaryTicket.api';
import { ISalaryTicket } from 'src/types/hr_ticket/salaryTicket.type';
import { AppContext } from 'src/contexts/app.context';

const { Text } = Typography;

interface Props {
  open: boolean;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
  onSuccess: (data: { salaryTicket: ISalaryTicket }) => void;
}

export default function ModalConfirm({ open, setOpen, onSuccess }: Props) {
  const { t } = useTranslation();
  const [form] = Form.useForm();
  const { userInfoQr } = useContext(AppContext);

  useEffect(() => {
    if (open) {
      form.resetFields();
    }
  }, [open, form]);

  const handleSubmit = async () => {
    try {
      const values = await form.validateFields();
      const response = await getPayslip({ verificationCode: values.verificationCode, employeeCode: userInfoQr?.code });

      if (response?.data && response.data.details?.length > 0) {
        onSuccess({
          salaryTicket: response.data
        });
        setOpen(false);
      } else {
        showNotification(t('Mã xác minh không đúng hoặc chưa có dữ liệu.'), 'error');
      }
    } catch (error: any) {
      console.error('Lỗi khi xác minh mã:', error);
    }
  };

  const handleCancel = () => {
    setOpen(false);
    form.resetFields();
  };

  return (
    <Modal
      title={
        <Flex gap={4}>
          <Text>Nhập mã xác minh</Text>
        </Flex>
      }
      centered
      maskClosable={false}
      open={open}
      onOk={handleSubmit}
      onCancel={handleCancel}
      footer={[
        <Button key='cancel' onClick={handleCancel}>
          {t('action.cancel')}
        </Button>,
        <Button key='submit' type='primary' onClick={handleSubmit}>
          {t('Xem lương')}
        </Button>
      ]}
    >
      <Form form={form} layout='vertical'>
        <Form.Item
          name='verificationCode'
          rules={[
            { required: true, message: 'Vui lòng nhập mã xác minh' },
            { len: 6, message: 'Mã xác minh phải gồm 6 số' }
          ]}
        >
          <Input
            type='password'
            placeholder='Nhập mã xác minh (6 số)'
            maxLength={6}
            autoComplete='one-time-code'
            name='password'
            onKeyDown={(e) => {
              const allowedKeys = ['Backspace', 'Delete', 'Ctrl', 'v'];
              if (!/[0-9]/.test(e.key) && !allowedKeys.includes(e.key)) {
                e.preventDefault();
              }
            }}
            onPaste={(e) => {
              const paste = e.clipboardData.getData('text');
              if (!/^\d+$/.test(paste)) {
                e.preventDefault(); // k cho paste nếu không phải toàn số
              }
            }}
          />
        </Form.Item>
      </Form>
    </Modal>
  );
}
